import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function markerHighlight() {
  const spans = document.querySelectorAll(".marker-highlight");
  if (!spans.length) return;

  spans.forEach((span) => {
    gsap.fromTo(
      span,
      { backgroundSize: "0% 100%" },
      {
        backgroundSize: "100% 100%",
        duration: 0.7,
        ease: "power2.out",
        scrollTrigger: {
          trigger: span,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      }
    );
  });
}
